const numberFormat = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 });
const dateTimeFormat = new Intl.DateTimeFormat(undefined, {
  year: "2-digit",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit"
});

export function formatNumber(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "—";
  return numberFormat.format(value);
}

export function formatHpWithTemp(hp: number | null | undefined, tempHp: number | null | undefined): string {
  const base = formatNumber(hp ?? null);
  const temp = Math.max(0, Math.floor(Number(tempHp ?? 0)));
  if (temp <= 0) return base;
  return `${base} (+${formatNumber(temp)})`;
}

export function formatGold(value: number | null | undefined, suffix: "g" | "gp" = "gp"): string {
  if (value == null || Number.isNaN(value)) return `— ${suffix}`;
  return `${formatNumber(value)} ${suffix}`;
}

export function formatMs(ms: number | null | undefined): string {
  if (ms == null || Number.isNaN(ms) || ms < 0) return "—";
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes <= 0) return `${seconds}s`;
  return `${minutes}m ${seconds.toString().padStart(2, "0")}s`;
}

export function formatDateTime(value: string | number | Date | null | undefined): string {
  if (value == null) return "—";
  const date = value instanceof Date ? value : new Date(value);
  const ts = date.getTime();
  if (!Number.isFinite(ts)) return "—";
  return dateTimeFormat.format(date);
}
